import React from "react";
import { Link } from "react-router-dom";
import Hero from "../components/Hero";
import SectionHead from "../components/SectionHead";
import ModulesGrid from "../components/ModulesGrid";
import FeaturesGrid from "../components/FeaturesGrid";
import SolutionCardGrid from "../components/SolutionCardGrid";
import BenefitsList from "../components/BenefitsList";
import ImpactGrid from "../components/ImpactGrid";
import ResourcesGrid from "../components/ResourcesGrid";
import FAQ from "../components/FAQ";
import CtaBanner from "../components/CtaBanner";
import ProductImage from "../components/ProductImage";
import ClientLogoCarousel from "../components/ClientLogoCarousel";
import Reveal from "../components/Reveal";
import Icon from "../components/Icon";
import { IMAGES, FAQS } from "../data/content";
import "../styles/home.css";
import FlowChart from "../components/FlowChart";
import playstore from "../assets/screenshots/play-store.svg";
import attendance from "../assets/screenshots/attendance-checkin.jpeg";

function Home() {
  return (
    <>
      <Hero />

      {/* Trusted by / client logos */}
      <section className="section section--tight" id="clients">
        <Reveal as="div" className="container">
          <p className="clients-eyebrow">
            Trusted by organizations across industries
          </p>
          <ClientLogoCarousel />
        </Reveal>
      </section>

      {/* Product explanation */}
      <section className="section" id="product-teaser">
        <Reveal as="div" className="container  product-teaser-grid">
          <div>
            <SectionHead
              eyebrow="Product overview"
              title="One connected system for attendance and HR"
            />
            <p className="section-subtitle product-teaser-copy">
              MPeoples HRMS gives employees and organizations a centralized
              platform for managing attendance and HR-related activities —
              reducing dependency on manual attendance processes with digital
              check-in and check-out, selfie-based verification, location
              tracking, leave and permission management, payroll and a web-based
              Admin Dashboard.
            </p>
            <Link to="/product" className="link-arrow">
              See the full product overview <Icon name="arrow" size={14} />
            </Link>
          </div>
          <ProductImage
            src={IMAGES.dashboardOverview}
            alt="MPeoples HRMS Admin Dashboard overview"
            frame="wide"
          />
        </Reveal>
      </section>

      {/* App store / PlayStore */}
      <section className="section section--app" id="modules-teaser">
        <Reveal as="div" className="container">
          <div className="home-checkin">
            <div className="section-head home-head">
              <div>
                <h2 className="section-title" style={{ color: "white" }}>
                  One App To Manage Every HR Task.
                </h2>
                <p className="section-subtitle" style={{ color: "white" }}>
                  Manage attendance, leave, permissions, approvals,
                  notifications, and more from anywhere. The Mpeoples HRMS
                  mobile app keeps your workforce connected and your HR
                  processes running smoothly.
                </p>
              </div>
              <div className="hrm-apps-download">
                <a
                  href="https://play.google.com/store/apps/details?id=com.mpeoples.mykonnect"
                  target="_blank"
                  title="Get it on Google Play"
                  class=""
                >
                  <img src={playstore} alt="Get it on Google Play" />
                </a>
              </div>
            </div>

            <div className="hero-phone hero-home-phone">
              <div className="hero-phone-notch" aria-hidden="true" />
              <img
                src={attendance}
                alt="MPeoples HRMS check-in screen"
                className="hero-phone-screen"
              />
            </div>
          </div>
        </Reveal>
      </section>

      {/* Solutions by workflow */}
      <section className="section section--alt" id="solutions-teaser">
        <Reveal as="div" className="container">
          <SectionHead
            eyebrow="Solutions"
            title="Built around real HR workflows"
            subtitle="Every module in MPeoples HRMS maps to a specific attendance or HR workflow."
            center
          />
          <SolutionCardGrid />
        </Reveal>
      </section>

      {/* Capabilities / modules highlight */}
      {/* <section className="section" id="modules-teaser">
        <Reveal as="div" className="container">
          <SectionHead
            eyebrow="Application modules"
            title="Everything branches from one app"
            subtitle="A centralized mobile application covering attendance, leave, payroll and more — supported by a web-based Admin Dashboard."
          />
          <ModulesGrid limit={6} />
          <div className="section-cta-link">
            <Link to="/product/modules" className="link-arrow">
              View all modules <Icon name="arrow" size={14} />
            </Link>
          </div>
        </Reveal>
      </section> */}

      {/* Features */}
      {/* <section className="section section--alt" id="features-teaser">
        <Reveal as="div" className="container">
          <SectionHead
            eyebrow="Features"
            title="The features that set it apart"
            subtitle="Combining selfie verification with location information provides a more transparent attendance process than a basic check-in / check-out system."
            center
          />
          <FeaturesGrid withHighlight={false} />
          <div className="section-cta-link section-cta-link--center">
            <Link to="/features" className="link-arrow">
              Explore all features <Icon name="arrow" size={14} />
            </Link>
          </div>
        </Reveal>
      </section> */}

      {/* Benefits / outcomes */}
      {/* <section className="section" id="benefits-teaser">
        <Reveal as="div" className="container  benefits-teaser-grid">
          <div>
            <SectionHead
              eyebrow="Benefits"
              title="Why organizations choose MPeoples HRMS"
            />
            <BenefitsList limit={6} />
            <Link to="/benefits" className="link-arrow">
              See all benefits <Icon name="arrow" size={14} />
            </Link>
          </div>
          <div>
            <h3 className="benefits-teaser-impact-title">Business impact</h3>
            <ImpactGrid />
          </div>
        </Reveal>
      </section> */}

      {/* Resources */}
      {/* <section className="section section--alt" id="resources-teaser">
        <Reveal as="div" className="container">
          <SectionHead
            eyebrow="Resources"
            title="From the product documentation"
            subtitle="MPeoples HRMS is documented end to end — from APIs to deployment and troubleshooting."
          />
          <ResourcesGrid limit={3} />
          <div className="section-cta-link">
            <Link to="/resources" className="link-arrow">
              Browse all resources <Icon name="arrow" size={14} />
            </Link>
          </div>
        </Reveal>
      </section> */}

      <FAQ
        items={FAQS}
        subtitle="Answers straight from the MPeoples HRMS product documentation."
      />

      <CtaBanner />
    </>
  );
}

export default Home;
